import PropTypes from 'prop-types';
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { add, load } from '../../../reducers/employees/employees.actions';
import { activeEmployees, inactiveEmployees, loading } from '../../../reducers/employees/employees.reducer';
import { Spinner } from '../../Spinner/Spinner';
import './AdminEmployees.css';
import ConnectedEmployeeForm from './EmployeeForm/EmployeeForm';

export class AdminEmployees extends React.Component {
  componentDidMount() {
    this.props.load();
  }

  render() {
    return (
      <span>
        <Spinner isLoading={this.props.areEmployeesLoading} />
        <Row style={{ 'margin-bottom': '15px' }}><Col><Button onClick={this.props.addEmployee} bsStyle="primary">Add New Employee</Button></Col></Row>
        {this.props.activeEmployees.map(employee => (
          <Row key={employee.id}>
            <Col>
              <ConnectedEmployeeForm employee={employee} />
            </Col>
          </Row>
          ))}
        <Row><Col><Button onClick={this.props.addEmployee} bsStyle="primary">Add New Employee</Button></Col></Row>
        <Row><Col><h4>Inactive Employees</h4></Col></Row>
        {this.props.inactiveEmployees.map(employee => (
          <Row key={employee.id}>
            <Col>
              <ConnectedEmployeeForm employee={employee} />
            </Col>
          </Row>
        ))}
      </span>
    );
  }
}

AdminEmployees.propTypes = {
  load: PropTypes.func.isRequired,
  addEmployee: PropTypes.func.isRequired,
  areEmployeesLoading: PropTypes.bool.isRequired,
  inactiveEmployees: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  activeEmployees: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export const mapStateToProps = state => ({
  areEmployeesLoading: loading(state),
  activeEmployees: activeEmployees(state),
  inactiveEmployees: inactiveEmployees(state),
});

export const mapDispatchToProps = dispatch => ({
  load: () => dispatch(load()),
  addEmployee: () => dispatch(add()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminEmployees);



// WEBPACK FOOTER //
// ./src/components/Admin/Employees/AdminEmployees.jsx